import Vue from "vue";
import VueI18n from 'vue-i18n';
Vue.use(VueI18n)

import en from './en'; //英文
import fr from './fr'; //法文
import sw from './sw'; //斯瓦希里语

const messages = {
    en: {...en},
    fr: {...fr},
    sw: {...sw}

}

const urlQueryStr = window.location.hash||''
const params = urlQueryStr.split('?')[1]||''
const allParmas = {}
params.split('&').forEach(item => {
    const key = item.split('=')[0]
    const value = item.split('=')[1]
    allParmas[key] = value
})
const languageMap = {
    'en-US': 'en',
    'fr-FR': 'fr',
    // 'es-ES': 'es',
    'sw-KE': 'sw',
}
// 如果url参数有lang，且是en或fr，保存到本地存储
if (allParmas.lang) {
  if (['en','fr','sw'].includes(allParmas.lang)) {
    // 保存语言设置到本地存储
    localStorage.setItem('language', allParmas.lang);
  }
}else if (navigator&&languageMap[navigator.language]) {
  // 如果浏览器语言是en-US或fr-FR，保存到本地存储
  // 保存语言设置到本地存储
    localStorage.setItem('language', languageMap[navigator.language]);
}
const i18n = new VueI18n({
    locale: localStorage.getItem('language') || 'en', // 默认语言
    messages
})

export default i18n;



// WEBPACK FOOTER //
// ./src/VueI18n/index.js